import * as types from './actionTypes';
import gradeInstanceApi from '../api/gradeInstanceApi';

export const getGradeInstancesSuccess = gradeInstances => ({
  gradeInstances,
  type: types.GET_GRADE_INSTANCES_SUCCESS
});

export const getGradeInstances = () =>
  dispatch =>
    gradeInstanceApi.get().then(({ gradeInstances }) => {
      dispatch(getGradeInstancesSuccess(gradeInstances));
    });



// WEBPACK FOOTER //
// ./src/actions/gradeInstanceActions.js